<template>
  <v-container
    fluid
    class="pattern-bg dark fill-height"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <material-card
          color="#a30000"
          :title="tokenMsg"
          v-if="tokenMsg && tokenMsg !== 'ok'"
        >
          <h3>Klik <a href="/forgot-password">disini</a> untuk mengakses halaman lupa password.</h3>
        </material-card>
        <material-card
          color="#a30000"
          title="Ubah Password"
          text="Lengkapi Ubah Password Anda"
          v-if="tokenMsg && tokenMsg === 'ok'"
        >
          <v-form
            ref="form"
            v-model="isFormValid"
          >
            <v-container class="py-0">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    ref="password"
                    v-model="defaultItem.password"
                    class="mt-5 ml-12 mr-4"
                    :rules="[() => !!defaultItem.password || 'Kolom harus terisi',
                             () => !!(defaultItem.password && defaultItem.password.match(/^(?=[A-Za-z0-9@#$%^&+!=().,<>?/{}_*|[\]\-:;'`~]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=().,<>?/{}_*|[\]\-:;'`~])(?=.{8,}).*$/))
                               || 'Password minimal memiliki 8 karakter dan terdiri dari huruf besar, kecil, angka dan karakter spesial']"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showPassword ? 'text' : 'password'"
                    prepend-inner-icon="mdi-lock"
                    label="Password Baru"
                    placeholder="Password Baru"
                    counter
                    required
                    outlined
                    @click:append="showPassword = !showPassword"
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    ref="password"
                    v-model="defaultItem.passwordNew"
                    class="mt-5 mr-12 ml-4"
                    :rules="[() => !!defaultItem.passwordNew || 'Kolom harus terisi',
                             () => (defaultItem.password === defaultItem.passwordNew) || 'Password harus sama dengan Password Baru']"
                    :append-icon="showPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showPassword1 ? 'text' : 'password'"
                    prepend-inner-icon="mdi-lock"
                    label="Konfirmasi Ulang Password Baru"
                    placeholder="Konfirmasi Ulang Password Baru"
                    counter
                    required
                    outlined
                    @click:append="showPassword1 = !showPassword1"
                  />
                </v-col>

                <!-- {{ defaultItem }} -->

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    :disabled="!isFormValid"
                    color="primary"
                    class="white--text"
                    @click="save"
                  >
                    Simpan
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="3500"
        :top="true"
      >
        {{ snackbarText }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { apiServer } from '../../setup-axios'
  import { sameAs, required } from 'vuelidate/lib/validators'

  export default {
    data: () => ({
      search: '',
      snackbar: false,
      snackbarText: '',
      snackbarColor: '',
      isLoading: true,
      isFormValid: false,
      menu: false,
      dialog: false,
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      defaultItem: {
        id: '',
        password: '',
        passwordNew: '',
      },
      tokenMsg: null,
    }),

    created () {
      this.validateToken()
      const userString = JSON.parse(localStorage.getItem('user'))
      console.log('cekidot ', userString)
    },

    methods: {
      validateToken () {
        apiServer
          .get('/userweb/checkToken/' + this.$route.params.token)
          .then(response => {
            this.tokenMsg = response.data[1] === 'ok' ? 'ok' : (response.data[1] === 'invalid token' ? 'Token invalid' : 'Token expired')
            this.defaultItem.id = response.data[0]
          })
          .catch(error => {
            console.log('There was an error:', error.response) // Logs out the error
            this.isLoading = false
          })
      },
      save () {
        apiServer
          .put('/userweb/token/change-password', this.defaultItem)
          .then(response => {
            this.showSnackbar('success', 'Password anda telah diubah')
            this.$refs.form.reset()
            setTimeout(() => {
              this.$router.replace('/home-page')
            }, 3000)
          })
          .catch(error => {
            console.log('There was an error:', error.response)
            this.showSnackbar('error', error.response.data)
          })
      },
      reset () {
        this.defaultItem.password = ' '
        this.defaultItem.passwordNew = ' '
      },
      showSnackbar (color, message) {
        console.log('snack ' + color + ' - ' + message)
        this.snackbar = true
        this.snackbarText = message
        this.snackbarColor = color
      },
    },
  }
</script>
<style scoped>
  .pattern-bg {
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.33' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='rotate(360 1000 750) scale(14.4) translate(-930.56 -697.92)'%3E%3Cg fill='%23F60'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
  }
</style>
